import { GridOptions, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { DateTime } from 'luxon';
import { environment } from '../../environments/environment';
import { AgGridDatetimeComponent } from '../components/ag-grid-datetime/ag-grid-datetime.component';

export const initializeAGGrid = () => {
  ModuleRegistry.registerModules([AllEnterpriseModule]);
  LicenseManager.setLicenseKey(environment.agGridKey);
};

export const defaultTableDefOptions: () => Partial<GridOptions> = () => ({
  rowHeight: 56,
  suppressContextMenu: false,
  getContextMenuItems: () => ['copy'],
  suppressRowHoverHighlight: true,
  suppressCellFocus: false,
  tooltipShowMode: 'whenTruncated',
  tooltipShowDelay: 100,
  tooltipTrigger: 'hover',
  domLayout: 'autoHeight',
  autoSizeStrategy: {
    type: 'fitGridWidth',
    defaultMinWidth: 100,
  },
  defaultColDef: {
    resizable: false,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
    cellClass: ['inline-flex', 'items-center'],
  },
  getRowClass: (params) => {
    if (params.node.rowIndex % 2 === 0) {
      return 'bg-slate-100';
    }
  },
  onGridReady: (params) => {
    params.api.sizeColumnsToFit();
  },
});

export const agGridDateTimeTableOptions = () => ({
  components: {
    agDateInput: AgGridDatetimeComponent,
  },
});

export const agGridDateTimeFilter = () => ({
  filter: 'agDateColumnFilter',
  filterParams: {
    inRangeInclusive: true,
    closeOnApply: true,
    maxNumConditions: 0,
    filterOptions: ['inRange'],
    buttons: ['apply', 'reset'],
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
      const checkCellDate = DateTime.fromISO(cellValue);
      const filterDate = DateTime.fromJSDate(filterLocalDateAtMidnight);

      if (checkCellDate > filterDate) return 1;
      if (checkCellDate < filterDate) return -1;

      return 0;
    },
  },
});
